import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';

import { Link } from 'core/routing';

import { useClientStore, useAppManager } from 'apps/hooks';

import FilesAppManager from 'apps/files/appManager';

import { CardSection } from 'legacyComponents/layout/cardSection';

import Button from 'components/Button';

import ShareCard from 'apps/share/blocks/shareCard';

const Files = observer(({ maxItems }) => {
  const clientStore = useClientStore();
  const shouldCreate = !!clientStore.signedInProfile;
  const appManager = useAppManager(FilesAppManager, null, {}, shouldCreate);

  if (!appManager) return null;
  const { sharedFilesConnection } = appManager;
  if (!sharedFilesConnection) return null;
  const sharedFiles = sharedFilesConnection.arrayApp;

  let numRows = sharedFiles?.length;
  if (!numRows) numRows = 0;

  let actions = null;
  if (numRows > 0) {
    actions = (
      <Link name='share-file'>
        <Button
          text={<Trans>Upload File</Trans>}
          size='small'
          icon='add'
          iconPosition='right'
          data-test-id='upload-file-button'
        />
      </Link>
    );
  }

  const { activeSpace } = clientStore;
  const title = activeSpace?.spaceType === 'INITIATIVE' ? 'Files' : 'My Files';

  return (
    <>
      <CardSection
        invisible={appManager.loading}
        title={title}
        subTitle=' '
        tooltip='Share new File.'
        isOwnProfile={false}
        owner
        ownerName={clientStore.signedInProfile.user.fullName}
        cardApp={sharedFiles}
        CardComponent={ShareCard}
        noDataCardType='sharedFile'
        gridColumns={1}
        actions={actions}
        maxItems={maxItems}
        showAllRouteName='workspace.spaceFiles'
        showAllRouteParams={{ spacePath: clientStore.activeSpace?.path }}
      />
    </>
  );
});

export default Files;
